module.exports = __webpack_public_path__ + "img/login-primerodemayocalzado.1ac5398d.svg";